import axios from 'axios'
import type {
  CreateContractRequest,
  CreateContractResponse,
  InsuranceParamsDto,
} from 'BrokerTsLib/src/dtos'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { Apis } from '@/appSettings'
import type { CommonMeetingRecord } from '@/dtos/CommonMeetingRecord'

import { useUrl } from '.'

export const useSaveInsuranceParams = () => {
  const url = useUrl(Apis.addonWizard)
  return useMutation({ mutationFn: (insuranceParams: InsuranceParamsDto) =>
    axios.post(`${url}/SaveInsuranceParams`, insuranceParams) })
}

export const useSaveBaseInsuranceParams = () => {
  const url = useUrl(Apis.addonWizard)
  return useMutation({ mutationFn: (insuranceParams: InsuranceParamsDto) =>
    // vrací true, pokud pro nabídku existuje aspoň jedna doplňková varianta
    axios.post<boolean>(`${url}/SaveBaseParams`, insuranceParams) })
}

export const useSaveSelectedAddonInsurance = () => {
  const url = useUrl(Apis.addonWizard)
  return useMutation({ mutationFn: (paramsId: number) =>
    axios.post(
      `${url}/SaveSelectedAddonInsurance?paramsId=${paramsId}`,
      undefined,
    ) })
}

export const useSaveMeetingRecord = () => {
  const url = useUrl(Apis.addonWizard)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (meetingRecord: CommonMeetingRecord) =>
      axios
        .post<CommonMeetingRecord>(`${url}/SaveMeetingRecord`, meetingRecord)
        .then((r) => r.data),
    onSuccess(data, variables, context) {
      queryClient.setQueryData(
        ['getMeetingRecord', variables.paramsId],
        () => {
          return data
        },
      )
    },
  })
}

export const useCreateContract = () => {
  const url = useUrl(Apis.addonWizard)
  return useMutation({ mutationFn: (request: CreateContractRequest) =>
    axios.post<CreateContractResponse>(`${url}/CreateContract`, request) })
}
